import { TenantConfig } from "./tenant-config";

export const Tenants = {
  HUS: new TenantConfig(
    "Hus Ltd",
    "https://hus-2.my.erp.net/api/domain/",
    "https://hustest.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),

  HUSTEST: new TenantConfig(
    "Hus Ltd",
    "https://hustest.my.erp.net/api/domain/",
    "https://hustest.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),

  MANIA: new TenantConfig(
    "Mania Ltd",
    "https://maniastoresbg.my.erp.net/api/domain/",
    "https://maniastoresbg.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),

  // ITC: new TenantConfig(
  //   "ITC Ltd",
  //   "https://itc-test.my.erp.net/api/domain/",
  //   "https://itc-test.my.erp.net/api/domain/"
  // ),

  ITC: new TenantConfig(
    "ITC Ltd",
    "https://itc-consult-demo.my.erp.net/api/domain/",
    "https://itc-consult-demo.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),

  ILINDEN: new TenantConfig(
    "Ilinden Ltd",
    "https://ilinden.my.erp.net/api/domain/",
    "https://ilinden.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  REALMET: new TenantConfig(
    "Realmet",
    "https://realmetcom.my.erp.net/api/domain/",
    "https://realmetcom.my.erp.net/api/domain/",
    false, //използва се в 202
  ),
  REALMETTEST: new TenantConfig(
    "Realmet Test",
    "https://realmet-test.my.erp.net/api/domain/",
    "https://realmet-test.my.erp.net/api/domain/",
    false, //използва се в 2022

  ),
  M2PROM: new TenantConfig(
    "M2PROM",
    "https://m2-prom.my.erp.net/api/domain/",
    "https://m2-prom.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  bio: new TenantConfig(
    "BIOFRESH",
    "https://biofresh.my.erp.net/api/domain/",
    "https://biofresh.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  fiore: new TenantConfig(
    "FIOREFOOD",
    "https://fiorefood.my.erp.net/api/domain/",
    "https://fiorefood.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  opticoelectron: new TenantConfig(
    "OpticoElectron",
    "https://opticoelectron.my.erp.net/api/domain/",
    "https://opticoelectron.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  opticoelectrontest: new TenantConfig(
    "OpticoElectronTest",
    "https://opticoelectron-test.my.erp.net/api/domain/",
    "https://opticoelectron-test.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  sbsdev: new TenantConfig(
    "SBSDev",
    "https://smartbsoftdev.my.erp.net/api/domain/",
    "https://smartbsoftdev.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  spgrid: new TenantConfig(
    "SmartPowerGrid",
    "https://spgridbg.my.erp.net/api/domain/",
    "https://spgridbg.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  spgridtest: new TenantConfig(
    "SmartPowerGrid Test",
    "https://spgridbg-test.my.erp.net/api/domain/",
    "https://spgridbg-test.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  mtg: new TenantConfig(
    "Метал Технолоджи Груп",
    "https://mtgbgcom.my.erp.net/api/domain/",
    "https://mtgbgcom.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
  mtgtest: new TenantConfig(
    "Метал Технолоджи Груп",
    "https://mtgbcom-test.my.erp.net/api/domain/",
    "https://mtgbcom-test.my.erp.net/api/domain/",
    false, //използва се в 2022
  ),
};
